var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelpGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.48438 8.90321V6.32322C3.48438 3.82989 5.50437 1.80322 8.0044 1.80322C10.4977 1.80322 12.5244 3.82322 12.5244 6.32322V9.44321V10.7099C12.5244 12.1299 11.3777 13.2766 9.95768 13.2766H6.89771",
    stroke: "#2B2A29",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.39021 10.2035C1.79021 10.2035 1.29688 9.71685 1.29688 9.11021V7.11017C1.29688 6.51017 1.78355 6.01685 2.39021 6.01685C2.99021 6.01685 3.48355 6.50351 3.48355 7.11017V9.11021C3.48355 9.71685 2.99021 10.2035 2.39021 10.2035Z",
    stroke: "#2B2A29",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6109 10.2035C13.0109 10.2035 12.5176 9.71685 12.5176 9.11021V7.11017C12.5176 6.51017 13.0042 6.01685 13.6109 6.01685C14.2109 6.01685 14.7042 6.50351 14.7042 7.11017V9.11021C14.7042 9.71685 14.2109 10.2035 13.6109 10.2035Z",
    stroke: "#2B2A29",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.68316 14.1964H6.81648C6.30982 14.1964 5.89648 13.7831 5.89648 13.2764C5.89648 12.7697 6.30982 12.3564 6.81648 12.3564H7.68316C8.18985 12.3564 8.60313 12.7697 8.60313 13.2764C8.60313 13.7831 8.18985 14.1964 7.68316 14.1964Z",
    fill: "#2B2A29"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpGray);
export default __webpack_public_path__ + "static/media/HelpGray.fbc1b7b69e8ef7a334d7d53ae07deabe.svg";
export { ForwardRef as ReactComponent };